<template>
  <div class="box">
    <div class="warpper">
      <div class="content">
        <div class="title">照片地址</div>
        <div class="details">地点：{{ queryData.poi }}</div>
        <div class="details">
          经纬度：{{ queryData.longitude }},{{ queryData.latitude }}
        </div>
      </div>
      <div class="navigation" @click="hrefs">导航到这里</div>
      <div class="content">
        <div class="title">水印信息</div>
        <div class="details">拍摄时间：{{ queryData.createdAt }}</div>
        <div class="details">地点：{{ queryData.poi }}</div>
      </div>
      <div class="imageBox">
        <img :src="queryData.uri" alt="" />
      </div>
    </div>
  </div>
</template>
  
  <script>
import "amfe-flexible";
// import { ActionSheet } from "vant";
import "vant/lib/index.css";
import Axios from "axios";
// import "@/util/libflexible";
//   import SurveyHeaderBar from "@/page/components/SurveyHeaderBar";
//   import { mapActions } from "vuex";
export default {
  data() {
    return {
      show: false,
      actions: [{ name: "高德地图" }, { name: "百度地图" }],
      queryData: {},
    };
  },
  mounted() {
    // http://192.168.31.204/demo/batch/scanCode
    const formData = new FormData();
      formData.append("id", this.$route.query.id);
    Axios.post(`${process.env.VUE_APP_API_EXPORT}scanCode`, formData).then(
      (res) => {
        this.queryData = res.data.data;
      }
    );
  },
  methods: {
    hrefs() {
      let data = `https://ditu.amap.com/dir?type=car&to%5Blnglat%5D=${this.queryData.longitude},${this.queryData.latitude}&to%5Bname%5D=${this.queryData.poi}&src=uriapi&innersrc=uriapi`;
      location.href = data;
    },
  },
  components: {},
};
</script>
<style lang="less" scoped>
.box {
  position: relative;
  height: 100vh;
  overflow: hidden;
}
.sheet-Dilog {
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
  left: 0;
  top: 0;
}
.sheet {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 4.92rem;
  text-align: center;
  background: #fff;
  width: 100%;
  border-radius: 0.28rem 0.28rem 0 0;
  .sheet-content {
    height: 3rem;
    .sheet-item {
      height: 33%;
      margin-bottom: 0.28rem;
      font-size: 0.5rem;
      line-height: 1rem;
    }
  }
  .close {
    font-size: 0.67rem;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
  }
}

.warpper {
  padding: 0.83rem 0.42rem;
  box-sizing: border-box;
}
.content {
  margin-bottom: 0.56rem;
}
.title {
  font-size: 0.67rem;
  color: #606a85;
  line-height: 0.8rem;
  margin-bottom: 0.56rem;
}
.details {
  font-size: 0.56rem;
  line-height: 0.7rem;
  margin-bottom: 0.4rem;
}
.navigation {
  width: 90%;
  height: 1.51rem;
  line-height: 1.51rem;
  text-align: center;
  font-size: 0.6rem;
  color: #fff;
  background-color: #0093ff;
  margin: auto;
  margin-bottom: 1.11rem;
  border-radius: 0.28rem;
  font-weight: bold;
}
.imageBox {
  height: 12.2rem;
}
img {
  width: 100%;
  height: 100%;
}
</style>